module.exports = __webpack_public_path__ + "static/media/order_black.09236ce1.svg";